import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './BidsDue.css';
import Date from 'components/shared/text/Date';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import QuoteStatus from 'components/shared/table/cell-addons/QuoteStatus';
import { usersUtil, TYPES } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';
import { getCurrentPage, getQuotes } from 'selectors/admin/quotes/quotes';
import { loadQuotesRequest } from 'actions/admin/quotes/quotes';
import { goToTask } from 'actions/admin/work-orders/details/details';

class BidsDue extends Component {
  static propTypes = {
    filters: PropTypes.shape(),
  };

  static defaultProps = {
    filters: {},
  };

  constructor(props) {
    super(props);

    this.spackle =
      usersUtil.isAdmin(props.currentUser) ||
      usersUtil.hasType(props.currentUser, TYPES.GENERAL_CONTRACTOR);
  }

  componentDidMount() {
    this.handlePageChange(1);
  }

  handlePageChange = (page) => {
    const { filters, dispatch } = this.props;
    dispatch(
      loadQuotesRequest(
        page,
        filters.waiting,
        filters.denied,
        filters.agg,
        filters.per_page
      )
    );
  };

  handleOpen = (id) => {
    const { quotes, dispatch } = this.props;
    const quote = quotes.content.find((quote) => quote.id === id);
    dispatch(goToTask(quote.work_order.id, quote.task.id));
  };

  handleGenerateLink = (id) => {
    const { quotes } = this.props;
    const quote = quotes.content.find((quote) => quote.id === id);
    return `work-orders/${quote.work_order.id}/task/${quote.task.id}`;
  };

  mapquotes = () => {
    const { quotes } = this.props;
    return quotes.content.map((quote) => {
      return {
        id: quote.id,
        data: [
          `${quote.work_order.number}-${quote.task.number}`,
          quote.work_order.name,
          quote.work_order.client.company_name,
          this.spackle ? quote.contractor_name : undefined,
          <Date
            className="bid-due-date"
            value={quote.task.bid_due_date}
            format="MM/DD/YYYY"
          />,
          <QuoteStatus status={quote.status} />,
        ].filter((field) => field !== undefined),
      };
    });
  };

  render() {
    const { quotes, currentPage } = this.props;
    return (
      quotes && (
        <div className="bids-due">
          <SimpleTable
            className={classnames({
              'projects-table': true,
              spackle: this.spackle,
            })}
            headers={[
              'WO #',
              'NAME',
              'CLIENT',
              this.spackle && 'CONTRACTOR',
              'BID DUE DATE',
              'STATUS',
            ].filter((header) => header)}
            rows={this.mapquotes()}
            emptyMessage="No quotes"
            onRowSelected={this.handleOpen}
            onGenerateLink={this.handleGenerateLink}
          />
          <div className="pagination-container">
            <SimplePagination
              currentPage={currentPage}
              pageSize={quotes.pageSize}
              total={quotes.total}
              onPageChange={this.handlePageChange}
            />
          </div>
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentPage: getCurrentPage(state),
    quotes: getQuotes(state),
  };
})(BidsDue);



// WEBPACK FOOTER //
// ./src/components/admin/quotes/BidsDue.js